// extracted by mini-css-extract-plugin
export const circle = "milestone-module--circle--2Fo4U";